import React from "react";
var SearchResult = function (props) {
    var _a;
    return (React.createElement("div", { className: "position-absolute bg-white search-result", onBlur: function () {
            props === null || props === void 0 ? void 0 : props.onBlur();
        } }, (_a = props === null || props === void 0 ? void 0 : props.body) !== null && _a !== void 0 ? _a : React.createElement(React.Fragment, null)));
};
export default SearchResult;
